module.exports = __webpack_public_path__ + "img/q_9_sor.f0365c35.png";